// extracted by mini-css-extract-plugin
module.exports = {"fullTestimonial":"ProjectGridsWithTransition_fullTestimonial__jbDTt","isSmallTestimonial":"ProjectGridsWithTransition_isSmallTestimonial__91sMg"};